import { useCallback, useState } from 'react';
import ReactFlow, { Controls, applyEdgeChanges, applyNodeChanges } from 'react-flow-renderer';

import initialNodes from './nodes.js';
import initialEdges from './edges.js';
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar'
import VariableSubHeader from '../../../../../component/common/layout/VariableSubHeader'
import Svg from '../../../../../component/common/Svg.js';
import { Link } from 'react-router-dom';

export default function Index() {

    const [nodes, setNodes] = useState(initialNodes);
    const [edges, setEdges] = useState(initialEdges);

    const onNodesChange = useCallback(
        (changes) => setNodes((nds) => applyNodeChanges(changes, nds)),
        [setNodes]
    );
    const onEdgesChange = useCallback(
        (changes) => setEdges((eds) => applyEdgeChanges(changes, eds)),
        [setEdges]
    );

    return (


        <div className='d-flex flex-column main-outer-wrapper main-site-wrapper'>
            <SurveyListHeader />
            <div id="viewport" className="d-flex">
                <SurveyListSidebar />
                <div className="flex-grow-1">
                    <VariableSubHeader />
                    <div className="page-content-wrap">
                        <div className='position-relative' style={{ height: 'calc(100vh - 186px)' }}>
                            <div className="page-heading mb-0 position-absolute top-0 left-0 z-index-9">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/survey/list">Survey</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="">Survey Name</Link>
                                        </li>

                                        <li className="breadcrumb-item active" aria-current="page"><strong>Question Logic</strong></li>
                                    </ol>
                                </nav>
                                <h1>Question Logic</h1>
                            </div>
                            <ReactFlow
                                nodes={nodes}
                                edges={edges}
                                onNodesChange={onNodesChange}
                                onEdgesChange={onEdgesChange}
                                fitView
                            >
                                <Controls />
                            </ReactFlow>
                        </div>
                        <div className="sidebar-logic show"> {/*Add Show Class on Click of Question and remove on click outside (ID of the node is provided in json)*/}

                            <div className="headding">
                                <h3>Question</h3>
                            </div>
                            <div className="question-wrapper">
                                <div className="question">
                                    <span>Q1</span>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit?
                                </div>
                                <ul className="options">
                                    <li><span>A</span> Lorem Ipsum</li>
                                    <li><span>B</span> Adipiscing elit</li>
                                    <li><span>C</span> Consectetur </li>
                                </ul>
                            </div>
                            <div className="edit-logic">
                                <h2>Edit logic</h2>
                                <div className="logic-wrap">
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="quesoptions" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            If
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="quesoptions">
                                            <a className="dropdown-item"> Option 1 </a>
                                            <a className="dropdown-item"> Option 2 </a>
                                            <a className="dropdown-item"> Option 3 </a>
                                        </div>
                                    </div>
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="quesoptions" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            Answer is
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="quesoptions">
                                            <a className="dropdown-item"> Option 1 </a>
                                            <a className="dropdown-item"> Option 2 </a>
                                            <a className="dropdown-item"> Option 3 </a>
                                        </div>
                                    </div>
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="quesoptions" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <span className='option'>C</span> Consectetur
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="quesoptions">
                                            <a className="dropdown-item">
                                                <span className='option'>A</span> Lorem Ipsum
                                            </a>
                                            <a className="dropdown-item">
                                                <span className='option'>B</span> Adipiscing elit
                                            </a>
                                            <a className="dropdown-item">
                                                <span className='option'>C</span> Consectetur
                                            </a>
                                        </div>
                                    </div>
                                    <h4>Then</h4>
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="quesoptions" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            Go to
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="quesoptions">
                                            <span class="dropdown-item-text">Numerical</span>
                                            <a className="dropdown-item"><Svg name="add" /> Add </a>
                                            <a className="dropdown-item"><Svg name="subtract" /> Substract </a>
                                            <a className="dropdown-item"><Svg name="multiply" /> Multiply </a>
                                            <a className="dropdown-item"><Svg name="divide" /> Divide </a>

                                        </div>
                                    </div>
                                    <div className="dropdown table-dropdown ques-options">
                                        <button className="btn dropdown-tgl" type="button" id="quesoptions" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false">
                                            <span className='me-2'>Q3</span> Lorem ipsum dolor sit amet
                                        </button>
                                        <div className="dropdown-menu" aria-labelledby="quesoptions">
                                            <a className="dropdown-item"> Lorem Ipsum </a>
                                            <a className="dropdown-item"> Adipiscing elit </a>
                                            <a className="dropdown-item"> Consectetur </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="logic-wrap logic-answer d-flex">
                                    <div className="flex-grow-1 text">All other cases</div>
                                    <span className='text me-3'>go to</span>
                                    <span className='question-count'>Q3</span>
                                </div>
                                <div className="button-wrap">
                                    <button className='btn btn-primary add-btn'>
                                        <Svg name="plus" /> Add Rule</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}